"use client";
import React from "react";
export const BgVideoContext = /*#__PURE__*/ React.createContext({
    isPlaying: true,
    togglePlay: ()=>undefined
});
